import { render, staticRenderFns } from "./act-list2.vue?vue&type=template&id=d0214a1c&scoped=true&"
import script from "./act-list2.vue?vue&type=script&lang=js&"
export * from "./act-list2.vue?vue&type=script&lang=js&"
import style0 from "./act-list2.vue?vue&type=style&index=0&id=d0214a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0214a1c",
  null
  
)

export default component.exports